/**
 * Join class names, dropping the falsy ones. The marketing pages have no `clsx` or
 * `tailwind-merge`; nothing here composes conflicting utilities, so a join is enough.
 */
export function cn(
  ...classes: ReadonlyArray<string | false | null | undefined>
): string {
  return classes.filter(Boolean).join(' ')
}
